module.exports = __webpack_public_path__ + "img/bg-position-white.e2f87577.png";